export default "__VITE_ASSET__BKJ27hCl__"